import { render, staticRenderFns } from "./qualificationDetails.vue?vue&type=template&id=349cf612&scoped=true"
import script from "./qualificationDetails.vue?vue&type=script&lang=js"
export * from "./qualificationDetails.vue?vue&type=script&lang=js"
import style0 from "./qualificationDetails.vue?vue&type=style&index=0&id=349cf612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349cf612",
  null
  
)

export default component.exports